<script>
import EtaDownloadRelatorio from '@/components/eta/EtaDownloadRelatorio.vue'
import EtaShowCharts from '@/components/eta/EtaShowCharts.vue'
import Loading from '@/components/Loading.vue'
import SliderRight from '@/components/SliderLeft.vue'
import auth, { roles } from '@/utils/auth'
import { endOfMonth, getLastMonths } from '@/utils/dateutils'
import http from '@/utils/http'
import { extractDateByMonthAndYear } from '@/utils/transform'

export default {
  name: 'EtaVisualizar',
  components: { EtaDownloadRelatorio, SliderRight, EtaShowCharts, Loading },
  data() {
    return {
      etaId: null,
      localId: null,
      eta: null,
      periodicidade: 'DIARIO',
      tiposDiponiveis: [],
      loadingData: true,
      data: null,
      mesesPesquisa: getLastMonths(12),
      from: new Date(Date.now() - 24 * 60 * 60 * 1000),
      to: new Date(),
      // Last 30 days
      fromSemanal: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000),
    }
  },
  computed: {
    isAdmin() {
      return auth.isAdmin()
    },
    canDownloadRelatorio() {
      return auth.isAdmin() || auth.hasRole(roles.ETA_RELATORIO)
    },
  },
  async beforeMount() {
    this.etaId = this.$route.params.etaId
    this.localId = this.$route.params.localId

    await this.loadData()
  },
  methods: {
    selectData(dataString) {
      if (dataString === null) {
        this.from = new Date(Date.now() - 24 * 60 * 60 * 1000)
        this.to = new Date()
        this.data = null
      } else {
        this.from = extractDateByMonthAndYear(dataString)
        this.to = endOfMonth(this.from)
      }

      this.loadData()
    },
    changePeriodicidade(periodicidade) {
      this.periodicidade = periodicidade
      this.loadData()
    },
    async loadData() {
      this.loadingData = true

      Promise.all([this.buscarEta(), this.tiposDisponiveisEta()]).finally(
        () => {
          this.loadingData = false
        }
      )
    },
    async buscarEta() {
      await http.eta.get(`eta/${this.etaId}`).then((data) => {
        this.eta = data
      })
    },
    async tiposDisponiveisEta() {
      await http.eta
        .get(`eta/${this.etaId}/tipos-usados`, {
          periodicidade: this.periodicidade,
        })
        .then((e) => {
          this.tiposDiponiveis = e
        })
    },
  },
}
</script>

<template>
  <div>
    <div class="row">
      <div class="col-4">
        <div class="row" style="align-items: baseline">
          <div class="hover-cursor ml-2 hover-cursor" @click="$router.back()">
            <md-icon class=""> arrow_back </md-icon>
          </div>
          <div class="ml-3">
            <h1 class="md-title">
              {{ eta === null ? 'Carregando...' : 'ETA - ' + eta.nome }} ETA
            </h1>
          </div>
        </div>
      </div>
      <div class="col-8">
        <div class="row justify-end" style="justify-content: flex-end">
          <router-link
            :to="{
              name: 'EtaEditar',
              params: {
                ...$route.params,
                etaId: eta && eta.id,
                periodicidade: periodicidade,
              },
            }"
          >
            <md-button v-if="isAdmin" class="md-primary flow-border-primary">
              <md-icon>edit</md-icon>
              EDITAR ETA
            </md-button>
          </router-link>

          <md-button
            v-if="canDownloadRelatorio"
            class="md-primary flow-border-primary"
            @click.stop="() => $refs.slider.toogleTab()"
          >
            <md-icon>file_download</md-icon>
            EXPORTAR RELATÓRIO
          </md-button>

          <router-link
            :to="{
              name: 'EtaMedicao',
              params: {
                ...$route.params,
                etaId: eta && eta.id,
                periodicidade: periodicidade,
              },
            }"
          >
            <md-button class="md-primary md-raised">
              <md-icon>add</md-icon>
              NOVA MEDIÇÃO
            </md-button>
          </router-link>
        </div>
      </div>
    </div>

    <div style="position: relative">
      <div>
        <md-tabs class="tab-eta" @md-changed="changePeriodicidade">
          <md-tab id="DIARIO" md-label="DIÁRIO">
            <loading :loading="loadingData" />
            <eta-show-charts
              v-if="!loadingData && periodicidade === 'DIARIO'"
              :tipos-diponiveis="tiposDiponiveis"
              :eta-id="etaId"
              :periodicidade="periodicidade"
              :from="from"
              :to="to"
              :show-dots="data === null"
            />
          </md-tab>
          <md-tab id="SEMANAL" md-label="SEMANAL">
            <loading :loading="loadingData" />

            <eta-show-charts
              v-if="!loadingData && periodicidade === 'SEMANAL'"
              :tipos-diponiveis="tiposDiponiveis"
              :eta-id="etaId"
              :periodicidade="periodicidade"
              :from="fromSemanal"
              :to="to"
              :show-dots="true"
            />
          </md-tab>
        </md-tabs>
      </div>

      <div style="position: absolute; right: 0; top: 0; z-index: 999">
        <div class="row" style="margin-right: 0; align-items: center">
          <div :class="`col-${data !== null ? 8 : 12}`">
            <md-field>
              <label for="data">Filtro por Data</label>
              <md-select
                id="data"
                v-model="data"
                name="data"
                @md-selected="selectData"
              >
                <md-option v-for="i in mesesPesquisa" :key="i" :value="i">
                  {{ i }}
                </md-option>
              </md-select>
            </md-field>
          </div>

          <div class="col-2">
            <md-button v-if="data !== null" @click="() => selectData(null)">
              <md-icon>close</md-icon>
            </md-button>
          </div>
        </div>
      </div>
    </div>

    <slider-right ref="slider" size="30%">
      <EtaDownloadRelatorio
        v-if="eta !== null"
        :eta="eta"
        @close="() => $refs.slider.toogleTab()"
      />
    </slider-right>
  </div>
</template>

<style lang="scss">
.hover-cursor:hover {
  cursor: pointer;
}

.flow-border-primary {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}

.tab-eta {
  div > button > .md-ripple {
    .md-button-content {
      font-size: 1rem;
      padding: 0 4rem 0 4rem;
    }
  }
}
</style>
